// components
import VoucherTable from '../../organisms/VoucherTable/VoucherTable';

const VoucherListPage = () => <VoucherTable />;

export default VoucherListPage;
